"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainScreen = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var doshx_controls_web_1 = require("doshx_controls_web");
var logo_png_1 = __importDefault(require("../assets/logo.png"));
var log_in_1 = require("./pages/log_in");
var sign_up_1 = require("./pages/sign_up");
var profile_1 = require("./pages/profile/profile");
var react_redux_2 = require("react-redux");
var main_1 = require("../reducers/slices/main");
var basket_1 = require("../reducers/slices/basket/basket");
var user_1 = require("../reducers/slices/user");
var forgot_password_1 = require("./pages/forgot_password");
var search_products_1 = require("../api/calls/product/search_products");
var selection_1 = require("../reducers/slices/selection");
var getRootPath_1 = require("../helpers/getRootPath");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var newsletter_subscribe_1 = require("../api/calls/user/newsletter_subscribe");
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var routes_1 = require("./routes");
var MainScreen = function () {
    var _a, _b, _c;
    var cookie = new universal_cookie_1.default();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var location = (0, react_router_dom_1.useLocation)();
    var rootPath = (0, getRootPath_1.getRootPath)(location);
    // const [drawerPageName, setDrawerPageName] = useState<"login" | "signup" | "forgot" | "profile">("login");
    var _d = (0, react_1.useState)(""), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = (0, react_1.useState)([]), searchPredictions = _e[0], setSearchPredictions = _e[1];
    var _f = (0, react_1.useState)(""), subscribingEmail = _f[0], setSubscribingEmail = _f[1];
    var _g = (0, react_1.useState)(""), subscribingEmailError = _g[0], setSubscribingEmailError = _g[1];
    var _h = (0, react_1.useState)(false), isBusySubscribing = _h[0], setIsBusySubscribing = _h[1];
    var _j = (0, react_1.useState)(false), userLoaded = _j[0], setUserLoaded = _j[1];
    var main = (0, react_redux_2.useSelector)(function (state) { return state.mainState; }).main;
    var user = (0, react_redux_2.useSelector)(function (state) { return state.userState; }).user;
    var basket = (0, react_redux_2.useSelector)(function (state) { return state.basketState; }).basket;
    (0, react_1.useEffect)(function () {
        //Get user in the cookie and set it in the store
        var userStateCookie = cookie.get("user_state");
        if (userStateCookie) {
            dispatch((0, user_1.setUser)(userStateCookie));
        }
        else {
            setUserLoaded(true);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (user.token) {
            setUserLoaded(true);
        }
    }, [user.token]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        //Get user in the cookie and set it in the store
        if (userLoaded && user) {
            if (!((_a = user === null || user === void 0 ? void 0 : user.location) === null || _a === void 0 ? void 0 : _a.lat) && !((_b = user === null || user === void 0 ? void 0 : user.location) === null || _b === void 0 ? void 0 : _b.lon) && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var newUserObj = __assign(__assign({}, user), { location: {
                            lat: position.coords.latitude,
                            lon: position.coords.longitude,
                        } });
                    dispatch((0, user_1.setUser)(newUserObj));
                }, function (error) {
                    console.error(error);
                });
            }
            else {
            }
        }
    }, [userLoaded]);
    (0, react_1.useEffect)(function () {
        if (user._id) {
            dispatch((0, basket_1.get_basket_thunk)());
        }
    }, [user._id]);
    (0, react_1.useEffect)(function () {
        var delayFn = setTimeout(function () {
            if (searchTerm) {
                (0, search_products_1.searchProducts)({
                    search_text: searchTerm,
                }).then(function (response) {
                    setSearchPredictions(response.content);
                });
            }
        }, 777);
        return function () { return clearTimeout(delayFn); };
    }, [searchTerm]);
    (0, react_1.useEffect)(function () { }, []);
    var openAccountPage = function () {
        if (user._id) {
            dispatch((0, main_1.setDrawerPage)("profile"));
            // navigate(`${rootPath}/profile`);
        }
        else {
            dispatch((0, main_1.setDrawerPage)("login"));
            // navigate(`${location.pathname}/login`);
        }
        dispatch((0, main_1.setDrawerOpen)(true));
    };
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.TopHeaderControl, { logo: { image: logo_png_1.default, size: "large", onClick: function () { return navigate("/"); } }, search: {
                iconColor: "text-primary",
                displayKey: "label",
                options: searchPredictions.map(function (prediction) { return ({
                    label: prediction.title,
                    value: prediction._id,
                }); }),
                searchChanged: function (value) {
                    setSearchTerm(value);
                },
                searchSelectionChanged: function (value) {
                    dispatch((0, selection_1.setSelectedProduct)({
                        _id: value.value,
                    }));
                    navigate("/product/".concat(value.value));
                },
            }, account: {
                displayText: user._id ? "".concat(user.name, " ").concat(user.surname) : undefined,
                iconColor: "text-white",
                backgroundColor: "bg-primary",
                onClick: function () {
                    // const strippedPath = getStrippedPath(location);
                    openAccountPage();
                },
            }, basket: {
                count: (_b = (_a = basket === null || basket === void 0 ? void 0 : basket.product_list) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
                onClick: function () { return navigate("/basket"); },
                countBackgroundColor: "bg-primary",
            }, topBar: {
                promotion: (react_1.default.createElement("div", { className: "flex flex-col md:flex-row items-center justify-center gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Try our new app and get in-app promotions! Available on the Android & iOS app stores.", textColor: "text-white", size: "large" }),
                    react_1.default.createElement(doshx_controls_web_1.AppStoreButtonsControl, { orientation: "horizontal", size: "small", appStore: {
                            onClick: function () {
                                window.open("https://apps.apple.com/us/app/mytlc-health-companion/id6443604249", "_blank");
                            },
                        }, playStore: {
                            onClick: function () {
                                window.open("https://play.google.com/store/apps/details?id=mytlc.mobile", "_blank");
                            },
                        } }))),
                actions: [
                    {
                        icon: pro_solid_svg_icons_1.faLocationDot,
                        label: "Find Store",
                        onClick: function () { return navigate("/find-store"); },
                    },
                    {
                        icon: pro_solid_svg_icons_1.faTruck,
                        label: "Track Your Order",
                        onClick: function () { return navigate("/track-your-order"); },
                    },
                    {
                        icon: pro_solid_svg_icons_1.faHeart,
                        label: "Wishlist",
                        onClick: function () { return navigate("/wishlist"); },
                    },
                ],
                colors: {
                    textColor: "text-white",
                    backgroundColor: "bg-success",
                    actions: {
                        iconColor: "text-white",
                        textColor: "text-white",
                        backgroundColor: "bg-primary",
                        underlineColor: "decoration-primary",
                    },
                },
            }, menu: {
                textColor: "text-black",
                dropdownBackgroundColor: "bg-primary",
                dropdownTextColor: "text-white",
                menuItems: [
                    {
                        label: "Home",
                        onClick: function () {
                            navigate("/home");
                        },
                    },
                    {
                        label: "About Us",
                        onClick: function () {
                            navigate("/about-us");
                        },
                    },
                    {
                        label: "News",
                        onClick: function () {
                            navigate("/news");
                        },
                    },
                    {
                        label: "Clinics",
                        onClick: function () {
                            navigate("/clinics");
                        },
                    },
                    {
                        label: "Rewards",
                        onClick: function () {
                            navigate("/choice-card");
                        },
                    },
                    {
                        label: "Contact Us",
                        onClick: function () {
                            navigate("/contact-us");
                        },
                    },
                    {
                        label: "Find Store",
                        onClick: function () {
                            navigate("/find-store");
                        },
                    },
                    {
                        label: "Book Clinic",
                        onClick: function () {
                            navigate("/clinic/booking");
                        },
                    },
                    {
                        label: "Join Our Family",
                        onClick: function () {
                            navigate("/become-franchisee");
                        },
                    },
                    {
                        backgroundColor: "bg-[#0132A9]",
                        textColor: "text-white",
                        label: "Shop Now",
                        //icon: faCartPlus,
                        iconColor: "text-primary",
                        onClick: function () {
                            navigate("/shop/categories");
                            if (location.pathname == "/shop/categories") {
                                navigate(0);
                            }
                        },
                    },
                ],
            } }),
        react_1.default.createElement(doshx_controls_web_1.DrawerControl, { open: main.isDrawerOpen, close: {
                backgroundColor: "bg-primary",
            }, toggleOpen: function (v) {
                dispatch((0, main_1.setDrawerOpen)(v));
            } }, (function () {
            switch (main.drawerPageName) {
                case "login":
                    return react_1.default.createElement(log_in_1.SignInPage, null);
                case "signup":
                    return react_1.default.createElement(sign_up_1.SignUpPage, null);
                case "profile":
                    return react_1.default.createElement(profile_1.ProfilePage, null);
                case "forgot":
                    return react_1.default.createElement(forgot_password_1.ForgotPasswordPage, null);
            }
        })()),
        react_1.default.createElement("div", { className: "pt-24 pb-10 " },
            react_1.default.createElement(routes_1.SiteRoutes, null)),
        react_1.default.createElement(doshx_controls_web_1.FooterControl, { backgroundColor: "bg-white", scrollWindowToTop: true, newsletter: {
                title: "Sign up for our newsletter",
                description: "Get news on promotions and more!",
                backgroundColor: "bg-primary",
                textColor: "text-white",
                onEmailChange: function (v) { return setSubscribingEmail(v); },
                emailAddress: subscribingEmail,
                input: {
                    errorText: subscribingEmailError,
                },
                button: {
                    backgroundColor: "bg-primary",
                    loading: isBusySubscribing,
                    onClick: function () {
                        setSubscribingEmailError("");
                        if (!subscribingEmail) {
                            setSubscribingEmailError("Please enter a valid email address.");
                        }
                        else {
                            setIsBusySubscribing(true);
                            (0, newsletter_subscribe_1.newsletter_subscribe)({
                                email: subscribingEmail,
                            }).then(function (response) {
                                setIsBusySubscribing(false);
                                if (response.success) {
                                    setSubscribingEmail("");
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Subscribed!",
                                        messages: ["You have successfully subscribed to our newsletter!"],
                                    }));
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Something went wrong!",
                                        messages: [response.message],
                                    }));
                                }
                            });
                        }
                    },
                },
            }, logo: {
                image: logo_png_1.default,
                size: "large",
            }, 
            // description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vitae aliquam aliquam, nisl nisl aliquam lorem, eget aliquam nisl nisl sit amet lorem."
            socialMedia: [
                {
                    icon: free_brands_svg_icons_1.faFacebook,
                    backgroundColor: "bg-gray-200",
                    onClick: function () {
                        window.open("https://www.facebook.com/thelocalchoicepharmacy/", "_blank");
                    },
                },
                {
                    icon: free_brands_svg_icons_1.faInstagram,
                    backgroundColor: "bg-gray-200",
                    onClick: function () {
                        window.open("https://www.instagram.com/thelocalchoice_pharmacy/", "_blank");
                    },
                },
                {
                    icon: free_brands_svg_icons_1.faXTwitter,
                    backgroundColor: "bg-gray-200",
                    onClick: function () {
                        window.open("https://twitter.com/thelocal_choice?s=11", "_blank");
                    },
                },
                {
                    icon: free_brands_svg_icons_1.faLinkedinIn,
                    backgroundColor: "bg-gray-200",
                    onClick: function () {
                        window.open("https://www.linkedin.com/company/the-local-choice-pharmacy/", "_blank");
                    },
                },
            ], shortcut: {
                links: [
                    {
                        label: "About Us",
                        onClick: function () {
                            navigate("/about-us");
                        },
                    },
                    {
                        label: "Join Our Family",
                        onClick: function () {
                            navigate("/become-franchisee");
                        },
                    },
                    {
                        label: "Franchisee Login",
                        onClick: function () {
                            window.open("https://mytlc.co.za/wp-login.php", "_blank");
                        },
                    },
                    {
                        label: "Terms & Conditions",
                        onClick: function () {
                            navigate("/terms-and-conditions");
                        },
                    },
                    {
                        label: "Privacy Policy",
                        onClick: function () {
                            navigate("/privacy-policy");
                        },
                    },
                    // {
                    //   label: "Login",
                    //   onClick: () => {
                    //     dispatch(setDrawerPage("login"));
                    //     dispatch(setDrawerOpen(true));
                    //   },
                    // },
                    // {
                    //   label: "Sign Up",
                    //   onClick: () => {
                    //     dispatch(setDrawerPage("signup"));
                    //     dispatch(setDrawerOpen(true));
                    //   },
                    // },
                    //
                ],
            }, customer: {
                title: "Customer Links",
                links: (user === null || user === void 0 ? void 0 : user._id)
                    ? [
                        { label: "My Account", onClick: function () { return openAccountPage(); } },
                        {
                            label: "Orders",
                            onClick: function () {
                                navigate("/orders");
                            },
                        },
                        {
                            label: "PAIA Manual",
                            onClick: function () {
                                var link = document.createElement("a");
                                link.href = "/documents/PAIA_Manual_TheLocalChoice_12July2021.pdf";
                                link.download = "PAIA_Manual_TheLocalChoice_12July2021.pdf";
                                document.body.appendChild(link);
                                link.click();
                            },
                        },
                        //
                    ]
                    : [
                        {
                            label: "Login",
                            onClick: function () {
                                dispatch((0, main_1.setDrawerPage)("login"));
                                dispatch((0, main_1.setDrawerOpen)(true));
                            },
                        },
                        {
                            label: "Sign Up",
                            onClick: function () {
                                dispatch((0, main_1.setDrawerPage)("signup"));
                                dispatch((0, main_1.setDrawerOpen)(true));
                            },
                        },
                        {
                            label: "Orders",
                            onClick: function () {
                                navigate("/orders");
                            },
                        },
                        {
                            label: "PAIA Manual",
                            onClick: function () {
                                window.open("https://thelocalchoice.co.za/wp-content/uploads/2021/08/PAIA_Manual_TheLocalChoice_12July2021.pdf", "_blank");
                            },
                        },
                    ],
            }, contact: {
                title: "Contact",
                description: "We are always happy to support you!",
                phone: {
                    number: "013 665 1698",
                    icon: pro_solid_svg_icons_1.faHeadset,
                    title: "Have any questions?",
                    onClick: function () {
                        window.open("tel:0136651698", "_blank");
                    },
                },
                // helpText: "Have any questions?",
                // phone: "013 665 1698",
                // chat: {
                //   label: "Live Chat",
                //   textColor: "text-white",
                //   backgroundColor: "bg-primary",
                //   onClick: () => {},
                // },
            }, copyright: {
                company: "DoshX",
                textColor: "text-black",
                backgroundColor: "bg-gray-200",
            } }),
        main.messageModal && (react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: main.messageModal.title, open: true, onClose: function () {
                dispatch((0, main_1.setMessageModal)(null));
            } },
            react_1.default.createElement("div", { className: "p-4" }, (_c = main.messageModal.messages) === null || _c === void 0 ? void 0 : _c.map(function (message, index) {
                return react_1.default.createElement("div", { key: "message-modal-".concat(index) }, message);
            })))),
        main.contentModal && (react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: main.contentModal.title, open: true, onClose: function () {
                dispatch((0, main_1.setContentModal)(null));
            } },
            react_1.default.createElement("div", { className: "p-4" }, main.contentModal.content)))));
};
exports.MainScreen = MainScreen;
